import { defaultHttpClient } from '../../httpClient';
import type { PopularKeywordsResponse } from '../types';

// 인기 검색어 리스트
export const getPopularKeywords = async (ageRange?: number) => {
  return defaultHttpClient
    .request<PopularKeywordsResponse>({
      method: 'GET',
      url: '/api/v2/search/popular_queries/',
      params: {
        age_range: ageRange ?? 0,
      },
    })
    .then(result => result.data);
};
